"use client";
import { Box, Backdrop, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { SpaceLg, ColorWhite, SpaceXs, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { Text } from "../../DataDisplay/Text/index.js";
const StyledActivityContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "showBackground"
})(({ showBackground }) => ({
  backgroundColor: showBackground ? ColorWhite : "transparent",
  padding: SpaceLg,
  borderRadius: "6px",
  zIndex: 100
}));
const StyledBackdrop = styled(Backdrop, {
  shouldForwardProp: (prop) => prop !== "isFullscreen"
})(({ isFullscreen }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: isFullscreen ? "fixed" : "unset",
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(255, 255, 255, 0.6)",
  zIndex: 99
}));
const StyledText = styled(Text, {
  shouldForwardProp: (prop) => prop !== "showText"
})(({ showText }) => ({
  ...showText ? {} : visuallyHidden,
  textAlign: "center",
  color: ColorGray900,
  marginTop: SpaceXs,
  "@media (prefers-reduced-motion)": {
    position: "unset",
    overflow: "unset",
    width: "auto",
    height: "auto",
    clip: "unset",
    whiteSpace: "unset",
    marginTop: 0
  }
}));
const StyledCircularProgress = styled(CircularProgress)`
    @media (prefers-reduced-motion) {
        display: none;
    }
`;
export {
  StyledActivityContainer,
  StyledBackdrop,
  StyledCircularProgress,
  StyledText
};
